import useApiHook from '../../../../hooks/api/useApiHook';
import { useCallback, useEffect } from 'react';

const TRADABLE_PRODUCTS_API_ROOT = '/tradable-products/buy';

export const useFetchProducts = (contract) => {
  const { getTradableProducts, loading, error, data } = useGetTradableProducts();
  const refreshProducts = useCallback(async () => {
    await getTradableProducts({
      contractId: contract.id,
      year: contract.contractPeriod,
      commodity: contract.commodity.id,
    });
  }, [contract, getTradableProducts]);
  useEffect(() => {
    refreshProducts();
  }, [refreshProducts]);
  return { loading, error, products: data, refreshProducts };
};

const useGetTradableProducts = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getTradableProducts = useCallback(async (payload) => {
    await get(
      `${TRADABLE_PRODUCTS_API_ROOT}?contractId=${payload.contractId}&year=${payload.year}&commodity=${payload.commodity}`,
    );
  }, [get]);
  return { getTradableProducts, data, error, loading };
};

